import PreviewWidgetCard from '../Common/PreviewWidgetCard';

function WallboardDataPreview({ boardData, queues}) {

 
    const getWidth = () => {
        if(boardData.widgets.length >= 13) { return '17%' }
        else { return '22%'}
    };
    
    const getHeight = () => {
        if(boardData.widgets.length <= 4) { return '45%' }
        else if (boardData.widgets.length <= 8) { return '35%' }
        else { return '25%'}
    };
    
    if(boardData.widgets.length > 0) {
        return (
            <>
                {boardData.widgets.map((widget, itx) => {
                  return (
                    <PreviewWidgetCard key={`wdigetcard-key-${itx}`} name={widget.name} threshold={widget.thresholds} statistic={widget.statistic[0]} cardWidth={getWidth()} cardHeight={getHeight()} theme={boardData.theme}/>
                  );
                })}
            </>
        );
    }
    else {
        return (
            <>
            </>
        );
    }
}

export default WallboardDataPreview;


